<template>
   <div class="titleBg">
     <div class="titTxt"><router-link :to="{ path: '/' }"  style="display:block;width:100%;height:100%"><img src="../assets/img/newxmzl/nybt.png" /> </router-link> </div>
     <img  src="../assets/img/syy.png"  class="return return1"  @click="clickReturn" />
     <div class="returnBox" v-if="nextShow"><router-link :to="{ path: pathUrl }"  ><img src="../assets/img/xyy.png" class="return return2" /></router-link> </div>
     <img :src="url + '/img/zhibo/gx.png'" class="guang1" />
     <img :src="url + '/img/zhibo/gx.png'" class="guang2" />
   </div>
</template>
<script setup  >

import { ref, onMounted, reactive } from "vue";
import * as echarts from "echarts";
import { useRouter } from "vue-router";
// console.log(props)
const props =defineProps({

  pathUrl: {
    type: String,
    default: () => "",
  },
  nextShow: {
    type: Boolean,
    default: () => true,
  },
})
const url = ref("https://lcamapp.oss-accelerate.aliyuncs.com/uploads/img")
const state = reactive({

})
const router = useRouter();
// 返回上一页
function clickReturn(){
  router.go(-1);
}
  onMounted(() => {


  });




</script>
<style lang="less" scoped>
 .titleBg{
  width: 100%;
  height: 174px;
  background: url('../assets/img/newxmzl/bt.png') no-repeat;
  position: relative;
   z-index: 999;
   .titTxt {
     width: 1801px;
     height: 59px;
     position: absolute;
     top: 36px;
     left: 50%;
     margin-left: -900.5px;
   }
   .returnBox{
     width:188px;
     height: 84px;
     cursor: pointer;
     position: absolute;
     top: 6px;
     right: 100px;
     z-index: 999;
   }
   .return {
     width:188px;
     height: 84px;
     cursor: pointer;
     position: absolute;
     top: 6px;
     z-index: 999;
   }
   .return1 {
     left: 100px;
   }
   .return2 {
     top: 0;
     right: 0;
   }
   .guang1{
     position: absolute;
     top: 36px;
     left: 0;
     animation: titleGuang1 1s linear infinite;
     z-index: 0;
   }
   .guang2{
     position: absolute;
     top: 36px;
     right: 0;
     animation: titleGuang2 1s linear infinite;
   }
   @keyframes titleGuang1{
     0%{
       left: 0;
     }
     100%{
       left: 9%;
     }
   }
   @keyframes titleGuang2{
     0%{
       right: 0;
     }
     100%{
       right: 9%;
     }
   }
 }
</style>
